<template>
  <div>
    <div class="data-filter-basic d-lg-none d-xl-none">
      <div class="row gx-0">
        <div class="col">
          <div class="mb-3">
            <label class="visually-hidden">Search</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-search"></i>
              </span>
              <input
                type="text"
                class="form-control"
                :value="filters.search"
                @input="updateSearch"
                placeholder="Search"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal modal-side-drawer-filters fade fixed-end op-lg op-xl"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title">Advanced Search</h2>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div class="modal-body">
            <div class="data-filters pt-3">
              <div class="mb-3">
                <label>Search</label>
                <div class="input-group">
                  <span class="input-group-text">
                    <i class="fal fa-search"></i>
                  </span>
                  <input
                    type="text"
                    class="form-control"
                    :value="filters.search"
                    @input="updateSearch"
                  />
                </div>
              </div>

              <button
                type="button"
                class="btn btn-block btn-primary d-lg-none d-xl-none"
              >
                Search
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'

export default {
  mixins: [useQueryParamFilters()],

  data () {
    return {
      filters: {
        search: null
      }
    }
  },

  computed: {
    updateSearch () {
      return debounce((event) => {
        this.filters.search = event.target.value
      }, this.filterManually ? 0 : 1000)
    }
  },

  watch: {
    queryParams: {
      handler (params) {
        this.$emit('input', params)
      },
      immediate: true
    }
  }
}
</script>
